<template>
  <footer class="footer-cta d-f fd-c ai-c jc-c">
    <div class="footer-cta-inner bc-brand p-lg bs-bb">
      <div class="footer-cta-main h-100 d-f fd-c ai-c jc-c">
        <p v-if="overline" class="tt-up m-b">{{ overline }}</p>
        <h1 v-if="titleHtml" v-html="titleHtml" class="ta-c tt-up"></h1>
        <router-link v-if="buttonTo" :to="buttonTo" class="button tt-up m-t-lg m-b-lg d-f ai-c jc-c g-half">
          <!-- {{ buttonText }} -->
          <span class="arrow-icon"><IconBase :w="30" :h="30"><IconArrowRight /></IconBase></span>
        </router-link>
        <p v-if="subtext" class="mute">{{ subtext }}</p>
      </div>
      <div class="footer-cta-bottom d-f fd-c ai-c jc-c font-small tt-up p mute g-half">
        <a class="d-f jc-c ai-c" href="#" @click.prevent="scrollToTop">Scroll to top</a>
        <div class="footer-cta-links d-f g">
          <router-link to="/legal/terms" class="mute">Terms</router-link>
          <router-link to="/legal/privacy" class="mute">Privacy</router-link>
          <router-link to="/legal/cookies" class="mute">Cookies</router-link>
          <a class="mute" href="javascript:Cookiebot.renew()">Consent</a>
        </div>
        <span class="footer-cta-copy">{{ copyright }}</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterCTA',
  components: {
    IconBase: () => import('@/assets/icons/IconBase.vue'),
    IconArrowRight: () => import('@/assets/icons/IconArrowRight.vue'),
  },
  props: {
    overline: {
      type: String,
      default: 'GET STARTED',
    },
    titleHtml: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: 'CREATE ACCOUNT →',
    },
    buttonTo: {
      type: [String, Object],
      default: '/sign_up',
    },
    buttonHref: {
      type: String,
      default: '',
    },
    subtext: {
      type: String,
      default: 'Free during beta. No credit card required.',
    },
    copyright: {
      type: String,
      default: '© 2026 MESHIN AB',
    },
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
@import "@/scss/_mixins.scss";


.footer-cta {
  height: 100vh;
}

.footer-cta-inner {
  margin: 0 auto;
  width: 100%;
  flex: 1;
  @media #{$mobile} {
    padding: $mg-desktop;
    h1 {
      font-size: 3em;
      line-height: 1.1;
    }
  }
  .button {
    width: 100%;
    max-width: 1200px;
    height: 20vw;
    overflow: hidden;
    &:hover {
      transform: scale(1.02);
      transition: transform 0.35s ease-in-out;
      .arrow-icon {
        animation: arrow-slide 0.5s ease forwards;
      }
    }
    @media #{$mobile} {
      height: 30vw;
    }
  }

  .arrow-icon {
    display: inline-flex;
  }

  @keyframes arrow-slide {
    0%   { transform: translateX(0);     opacity: 1; }
    45%  { transform: translateX(120%);  opacity: 0; }
    46%  { transform: translateX(-120%); opacity: 0; }
    100% { transform: translateX(0);     opacity: 1; }
  }
}


</style>
